/**
 * 악덕알리미 설정 허브 (테마/글자크기/푸시).
 *  - 영속화 : 테마·글자크기는 **기기(localStorage — window.BD)**, 푸시는 서버(app_config.apps.BD).
 *    화면설정은 기기 설정이라 계정·기기 간에 이어지지 않는다. 푸시(alertMode)는 네이티브 계약이라 서버 보관.
 *  - 네이티브 동기화 : appBroker 'syncSettings' — push.alertMode + member.mbno 만 전송.
 *    (BD 계약: 20260527_BADCALL_APP_BROKER_ACTIONS.md §6. theme/fontsize 는 네이티브 미전송)
 *  목록형 설정(체불번호감지/통화이력공유)은 BS 로 연다($j.F.Devil.Settings.openCallBlock/openCallShare).
 */
import Util from '../../Common/Util';


const CFG_URL = '/b/ajax/settings/app-config';
const DEFAULTS = { theme: 'light', fontsize: 'm', push: 'sound' };

export default class Settings {
    initialize() {
        // 세그먼트별 화면 적용기 — theme/fontsize 는 window.BD 로 즉시 렌더, push 는 DOM 영향 없음(네이티브 전용)
        this.apply = {
            theme:    (v) => window.BD && window.BD.setTheme(v),
            fontsize: (v) => window.BD && window.BD.setFontSize(v),
            push:     () => {},
        };
        this.cur = { ...DEFAULTS };
        // 화면 모드/글자 크기는 부트 스크립트가 기기값으로 이미 적용한 상태다(<head>, 첫 페인트 전).
        // 그 적용값(DOM)을 출발점으로 삼아, 새로고침 시 기본값(light)으로 되돌려지는 회귀를 막는다.
        if (window.BD) {
            this.cur.theme    = window.BD.getTheme();
            this.cur.fontsize = window.BD.getFontSize();
        }

        Object.keys(this.apply).forEach((g) => this.bindSeg(g));
        $('#b-set-withdraw').on('click', () => this.confirmWithdraw());
        $('#b-set-logout').on('click', () => this.confirmLogout());
        // 하위 설정·약관·공지 — 시트(BS)로 연다
        const OPEN = {
            callBlock: () => $j.F.Devil.Settings.openCallBlock(),
            callShare: () => $j.F.Devil.Settings.openCallShare(),
            terms:     () => $j.F.Devil.Terms.open(),
            notice:    () => $j.F.Devil.Notice.open(),
        };
        $('[data-set-act]').on('click', (e) => {
            e.preventDefault();
            OPEN[e.currentTarget.dataset.setAct]();
        });

        this.hydrate();
    }

    // data-seg-group 버튼 클릭 → 현재값 갱신 + 렌더 + 서버저장 (+ push 는 네이티브 동기화)
    bindSeg(group) {
        const self = this;
        $(`[data-seg-group="${group}"]`).find('.b-seg').on('click', function () {
            const v = $(this).data('val');
            self.cur[group] = v;
            self.apply[group](v); // 화면 반영
            self.syncUi(group);   // 버튼 활성표시
            self.persist(group, v);
        });
    }

    // 버튼 활성표시 동기화
    syncUi(group) {
        const v = this.cur[group];
        $(`[data-seg-group="${group}"] .b-seg`).each((i, el) => $(el).toggleClass('is-on', $(el).data('val') === v));
    }

    // 영속화 — theme/fontsize 는 window.BD 가 이미 기기(localStorage)에 저장했다(apply 단계).
    // 서버로 보내는 것은 push 뿐이고, 같은 값이 네이티브(alertMode)로도 간다.
    persist(field, value) {
        if (field !== 'push') return;
        const payload = {}; payload[field] = value;
        $.post(CFG_URL, payload); // 실패해도 화면은 이미 반영됨
        this.syncNative();
    }

    // 네이티브 동기화 (appBroker syncSettings) — BD 계약: push.alertMode + member.mbno (2-depth).
    // 앱 미탑재(브라우저)면 runAppBroker 가 자동 no-op.
    syncNative() {
        if (!(window.$j && $j.F && $j.F.App && typeof $j.F.App.syncSettings === 'function')) return;
        const settings = { push: { alertMode: this.cur.push } };
        const mbno = (typeof MEMBER !== 'undefined') ? Util.int(MEMBER.num) : 0;
        if (mbno) settings.member = { mbno };
        $j.F.App.syncSettings(settings);
    }

    // 진입 시 정렬 — push 만 서버값(MEMBER.app_config, getMemberJs 로 이미 실려옴. 추가 ajax 없음).
    // theme/fontsize 는 기기값이 정본이고 initialize 에서 DOM(부트 스크립트 적용값)으로 이미 잡았다
    // — 여기서 서버값을 덮으면 방금 기기에 저장한 선택이 옛 DB값으로 되돌아간다.
    // 진입 시 네이티브 정렬(alertMode+mbno)은 Sites/Devil/Bootstrap 이 공통 처리 → 여기선 화면만.
    hydrate() {
        const cfg = (typeof MEMBER !== 'undefined' && MEMBER && MEMBER.app_config) ? MEMBER.app_config : {};
        if (cfg.push != null) this.cur.push = cfg.push;
        this.applyAll();
    }

    applyAll() {
        Object.keys(this.apply).forEach((g) => { this.apply[g](this.cur[g]); this.syncUi(g); });
    }

    // 탈퇴 — BS 2단계(안내사항 → 최종확인) → POST /b/leave → 로그아웃.
    // 데이터 처리: 제보(작성중 삭제·제출분 익명화 보관) / 통화이력공유·차단 삭제 / BD 푸시 해제.
    confirmWithdraw() {
        if (!(window.$j && $j.Ui && $j.Ui.BS)) return;
        $j.Ui.BS.open({ target: this._withdrawTarget(), fixedHeight: true, backClose: true });
    }

    // 로그아웃 — 확인창 → 예 → appBroker('logout') 통지 후 약간의 텀을 두고 /b/logout 이동.
    // 색/테마는 devil/components/_dialog.scss 가 담당한다.
    confirmLogout() {
        const self = this;
        $j.Ui.Dialog.open({
            tone:    'info',
            title:   '로그아웃',
            desc:    '로그아웃 하시겠습니까?',
            confirm: '로그아웃',
            cancel:  '취소',
        }).then((ok) => { if (ok) self._doLogout(); });
    }

    // 앱에 로그아웃 통지 후 지연 이동. location.replace 로 히스토리 누적 방지(안드로이드 백버튼 대응).
    _doLogout() {
        if (window.$j && $j.F && $j.F.App && typeof $j.F.App.logout === 'function') {
            $j.F.App.logout();
        }
        setTimeout(() => location.replace('/b/logout'), 300);
    }

    _withdrawTarget() {
        const self = this;
        return {
            init() {
                this.parent.setTitle('서비스 해지');
                self._renderWarn($('#' + this.id), this.parent);
            },
            destroy() {},
        };
    }

    // 1단계 — 삭제 항목 안내
    _renderWarn($cont, bs) {
        const self = this;
        const items = [
            { t: '내 제보 내역 삭제', d: '동일건 제보자간 안심번호 통화 불가' },
            { t: '통화이력 공유 데이터 삭제', d: '공개 통화이력을 통한 연락 불가' },
            { t: '정정 요청 연결 해제', d: '체불업체와의 안심번호 통화 불가' },
            { t: '안심번호 해제', d: '발급된 안심번호 즉시 만료' },
        ];
        const list = items.map((m, i) => `
            <div style="padding:12px 16px;${i < items.length - 1 ? 'border-bottom:1px solid var(--sf2);' : ''}">
                <p style="font-size:14px;font-weight:600;color:var(--t1)">${i + 1}. ${m.t}</p>
                <p style="font-size:12px;color:var(--t2);margin-top:2px">${m.d}</p>
            </div>`).join('');

        $cont.html(`
            <div style="padding:14px 14px 30px">
                <p style="font-size:13px;color:var(--t3);line-height:1.6;text-align:center">서비스 해지시 아래 항목이 모두 삭제되며<br>다른 회원과의 연결이 해제됩니다.</p>
                <div style="border:1px solid var(--bdr);border-radius:12px;overflow:hidden;margin:10px 0 14px">${list}</div>
                <p style="font-size:12px;color:var(--R);text-align:center;margin-bottom:16px">⚠️ 해지된 데이터는 복구할 수 없습니다.<br>장비불러 계정은 유지됩니다.</p>
                <div style="display:flex;gap:8px">
                    <button type="button" class="bw-cancel" style="flex:1;height:48px;border-radius:14px;border:1.5px solid var(--bdr);background:var(--sf);cursor:pointer;font-size:15px;font-weight:600;color:var(--t1)">취소</button>
                    <button type="button" class="bw-next" style="flex:1;height:48px;border-radius:14px;border:none;background:var(--R);cursor:pointer;font-size:15px;font-weight:600;color:#fff">해지</button>
                </div>
            </div>`);

        $cont.find('.bw-cancel').on('click', () => bs.close());
        $cont.find('.bw-next').on('click', () => self._renderConfirm($cont, bs));
    }

    // 2단계 — 최종 확인
    _renderConfirm($cont, bs) {
        const self = this;
        $cont.html(`
            <div style="padding:24px 16px 30px;text-align:center">
                <p style="font-size:17px;font-weight:700;color:var(--t1)">정말 서비스를 해지하시겠습니까?</p>
                <p style="font-size:13px;color:var(--t3);margin-top:12px;line-height:1.6">삭제된 데이터는 <span style="color:var(--R);font-weight:600">복구할 수 없으며</span><br>모든 연결이 <span style="color:var(--R);font-weight:600">즉시 해제</span>됩니다.</p>
                <div style="display:flex;gap:8px;margin-top:20px">
                    <button type="button" class="bw-cancel2" style="flex:1;height:48px;border-radius:14px;border:1.5px solid var(--bdr);background:var(--sf);cursor:pointer;font-size:15px;font-weight:600;color:var(--t1)">취소</button>
                    <button type="button" class="bw-final" style="flex:1;height:48px;border-radius:14px;border:none;background:var(--R);cursor:pointer;font-size:15px;font-weight:600;color:#fff">해지</button>
                </div>
            </div>`);

        $cont.find('.bw-cancel2').on('click', () => bs.close());
        $cont.find('.bw-final').on('click', function () {
            const $btn = $(this).prop('disabled', true).text('처리 중…');
            $.ajax({
                type: 'POST',
                url: '/b/leave',
                dataType: 'json',
                success(data) {
                    if (data && data.result) {
                        location.replace(data.redirect || '/b/logout');
                    } else {
                        alert((data && data.message) || '해지 처리에 실패했습니다.');
                        $btn.prop('disabled', false).text('해지');
                    }
                },
                error() {
                    alert('해지 처리 중 오류가 발생했습니다.');
                    $btn.prop('disabled', false).text('해지');
                },
            });
        });
    }
}
